import { useState } from "react";
import React from "react";
import { Box, Button, Checkbox, Divider, FormControlLabel } from "@mui/material";
import { MultipleSelectFilterParameter } from "../models/customerModels";
import useTranslation from "../../../shared/hooks/useTranslation";

interface MultipleSelectFilterProps {
  parameters: MultipleSelectFilterParameter[];
  title?: string;
  maxLength?: number;
  onChange?: (value: (number | string)[]) => void;
  renderParameterName?: (parameter: MultipleSelectFilterParameter) => string;
}

const MultipleSelectFilter = ({
  parameters,
  title,
  maxLength = 8,
  onChange,
  renderParameterName = parameter => parameter.name
}: MultipleSelectFilterProps) => {
  const [isMoreItem, setIsMoreItem] = useState(false);
  const { translate } = useTranslation("common");

  const handleShowMore = () => {
    setIsMoreItem(!isMoreItem);
  };

  const handleFilterParameterClick = (event: any, id: string | number) => {
    const {
      target: { checked }
    } = event;

    let newValue = parameters.filter(x => x.isEnabled).map(x => x.id);
    newValue = checked ? [...newValue, id] : newValue.filter(x => x !== id);

    onChange?.(newValue);
  };

  return (
    <>
      {parameters?.length > 0 && (
        <Box>
          <Box className="text-14-medium" color="#333333">
            {title ?? translate("filter")}
          </Box>

          {parameters.slice(0, isMoreItem ? parameters.length : maxLength).map((parameter) => (
            <Box key={parameter.id} className="flex items-center gap-2">
              <FormControlLabel
                className="w-full"
                control={
                  <Checkbox
                    checked={parameter.isEnabled}
                    name={title}
                    onClick={(event) => handleFilterParameterClick(event, parameter.id)}
                  />
                }
                label={
                  <Box className={parameter.isEnabled ? "text-14-medium" : "text-14-regular"} color="#333333">
                    {renderParameterName(parameter)}
                  </Box>
                }
              />

              <Box className="text-14-medium">{parameter.value}</Box>
            </Box>
          ))}

          {parameters.length > maxLength && (
            <Button variant="text" className="text-14-medium" onClick={handleShowMore}>
              {isMoreItem ? translate("showLess") : `${translate("showMore")} (${parameters.length - maxLength})`}
            </Button>
          )}

          <Box className="w-full mt-2 mb-2">
            <Divider />
          </Box>
        </Box>
      )}
    </>
  );
};

export default MultipleSelectFilter;